import { Dictionary } from "@/types/utils.types";

import { ReactComponent as AccessTime } from "./access-time.svg";
import { ReactComponent as Add } from "./add.svg";
import { ReactComponent as AlignJustifySolid } from "./align-justify-solid.svg";
import { ReactComponent as Article } from "./article.svg";
import { ReactComponent as ArrowBack } from "./arrow_forward_24px.svg";
import { ReactComponent as ArrowLeft } from "./arrow_left.svg";
import { ReactComponent as ArrowRight } from "./arrow_right.svg";
import { ReactComponent as ArrowForward } from "./arrow-forward.svg";
import { ReactComponent as Calendar } from "./calendar.svg";
import { ReactComponent as Chat } from "./chat.svg";
import { ReactComponent as ChatWithNotification } from "./chat_with_notification.svg";
import { ReactComponent as Check } from "./check.svg";
import { ReactComponent as CheckCircleSolid } from "./check-circle-solid.svg";
import { ReactComponent as CheckCirle } from "./circle-check.svg";
import { ReactComponent as Close } from "./close.svg";
import { ReactComponent as Code } from "./code.svg";
import { ReactComponent as CompanyLogo } from "./company-logo.svg";
import { ReactComponent as Comment } from "./comment.svg";
import { ReactComponent as Cross } from "./cross.svg";
import { ReactComponent as DoubleArrowLeft } from "./double-arrow-left.svg";
import { ReactComponent as DoubleArrowRight } from "./double-arrow-right.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as Email } from "./email.svg";
import { ReactComponent as Error } from "./error.svg";
import { ReactComponent as ErrorOutline } from "./error_outline_24px.svg";
import { ReactComponent as Exit } from "./exit.svg";
import { ReactComponent as ExpandLess } from "./expand-less.svg";
import { ReactComponent as ExpandMore } from "./expand-more.svg";
import { ReactComponent as FilterList } from "./filter-list.svg";
import { ReactComponent as File } from "./file.svg";
import { ReactComponent as Upload } from "./upload.svg";
import { ReactComponent as HelpOutline } from "./help_outline.svg";
import { ReactComponent as HighlightOff } from "./highlight-off.svg";
import { ReactComponent as Info } from "./info_outline_24px.svg";
import { ReactComponent as LockSolid } from "./lock-solid.svg";
import { ReactComponent as Mic } from "./mic_24px.svg";
import { ReactComponent as MicOff } from "./mic_off.svg";
import { ReactComponent as MicEnabled } from "./mic_enabled.svg";
import { ReactComponent as Minimise } from "./minimize.svg";
import { ReactComponent as NightlightRound } from "./nightlight_round.svg";
import { ReactComponent as People } from "./people-alt.svg";
import { ReactComponent as Phone } from "./phone.svg";
import { ReactComponent as ProgressActivity } from "./progress_activity.svg";
import { ReactComponent as PlayArrow } from "./play-arrow.svg";
import { ReactComponent as RemoveRedEye } from "./remove-red-eye.svg";
import { ReactComponent as OpenInNew } from "./open-in-new.svg";
import { ReactComponent as ScreenCapture } from "./screen-capture.svg";
import { ReactComponent as Send } from "./send.svg";
import { ReactComponent as Settings } from "./settings.svg";
import { ReactComponent as SignalCellular } from "./signal-cellular.svg";
import { ReactComponent as SignalCellularGood } from "./signal-cellular-good.svg";
import { ReactComponent as SignalCellularLow } from "./signal-cellular-low.svg";
import { ReactComponent as SignalCellularBad } from "./signal-cellular-bad.svg";
import { ReactComponent as SpaceDashboard } from "./space_dashboard.svg";
import { ReactComponent as SpinnerSolid } from "./spinner-solid.svg";
import { ReactComponent as Star } from "./star.svg";
import { ReactComponent as StarBorder } from "./star-border.svg";
import { ReactComponent as Timer } from "./timer.svg";
import { ReactComponent as Separator } from "./Vector 378.svg";
import { ReactComponent as WebCam } from "./videocam_24px.svg";
import { ReactComponent as WebCamOff } from "./videocam_off.svg";
import { ReactComponent as WebCamEnabled } from "./webcam_enabled.svg";
import { ReactComponent as Warning } from "./warning_amber_24px.svg";
import { ReactComponent as ZoomContract } from "./zoom_contract.svg";
import { ReactComponent as ZoomExpand } from "./zoom_expand.svg";
import { ReactComponent as ZoomFullScreen } from "./zoom_full_screen.svg";
import { ReactComponent as ZoomElipsis } from "./zoom-elipsis.svg";

const Icons: Dictionary<
  React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>
> = {
  add: Add,
  alignJustifySolid: AlignJustifySolid,
  arrowLeft: ArrowLeft,
  arrowForward: ArrowForward,
  arrowRight: ArrowRight,
  accessTime: AccessTime,
  calendar: Calendar,
  chat: Chat,
  checkCircle: CheckCirle,
  check: Check,
  close: Close,
  code: Code,
  comment: Comment,
  doubleArrowLeft: DoubleArrowLeft,
  doubleArrowRight: DoubleArrowRight,
  download: Download,
  upload: Upload,
  file: File,
  defaultCompanyLogo: CompanyLogo,
  exit: Exit,
  expandLess: ExpandLess,
  expandMore: ExpandMore,
  filterList: FilterList,
  helpOutline: HelpOutline,
  highlightOff: HighlightOff,
  lockSolid: LockSolid,
  nightlightRound: NightlightRound,
  playArrow: PlayArrow,
  progressActivity: ProgressActivity,
  people: People,
  removeRedEye: RemoveRedEye,
  openInNew: OpenInNew,
  screenCapture: ScreenCapture,
  settings: Settings,
  signalCellular: SignalCellular,
  signalCellularGood: SignalCellularGood,
  signalCellularLow: SignalCellularLow,
  signalCellularBad: SignalCellularBad,
  spaceDashboard: SpaceDashboard,
  spinnerSolid: SpinnerSolid,
  webCam: WebCam,
  webCamOff: WebCamOff,
  webCamEnabled: WebCamEnabled,
  mic: Mic,
  micOff: MicOff,
  micEnabled: MicEnabled,
  checkCircleSolid: CheckCircleSolid,
  cross: Cross,
  send: Send,
  info: Info,
  arrowBack: ArrowBack,
  error: Error,
  errorOutline: ErrorOutline,
  star: Star,
  starBorder: StarBorder,
  separator: Separator,
  timer: Timer,
  warning: Warning,
  zoomExpand: ZoomExpand,
  zoomContract: ZoomContract,
  zoomFullScreen: ZoomFullScreen,
  minimise: Minimise,
  zoomElipsis: ZoomElipsis,
  chatWithNotification: ChatWithNotification,
  article: Article,
  email: Email,
  phone: Phone,
};

export default Icons;
